import { pt_br } from '../i18n/pt_br'
import { en_us } from '../i18n/en_us'

export function i18n(message: string): string {
    const locale = window.Live.settings && window.Live.settings.locale ? window.Live.settings.locale : null
    if (!locale) return message

    const values = locale !== 'pt_br' ? en_us : pt_br

    if (locale === 'pt_br') {
        return values[message]
    }

    return values[message]
}
